import { Stack } from "flicket-ui";
import { useContext } from "react";
import { SinglePageCheckoutListItem } from "~features/checkout/pre-auth/components/OrderSummary/ListItem";
import { OrderSummaryContext } from "~features/checkout/pre-auth/components/OrderSummary/OrderSummaryContext";

export const ExpressCheckoutSummary = ({
  totalToBePaid,
}: {
  totalToBePaid: number;
}) => {
  const { isLoading } = useContext(OrderSummaryContext);

  return (
    <Stack direction={"vertical"} gap={1}>
      <SinglePageCheckoutListItem
        title={"Total"}
        price={totalToBePaid}
        variant="header.S"
        isLoading={isLoading}
      />
    </Stack>
  );
};
